const uuidv1 = require('uuid/v1')
function generateDeviceId () {
  const DeviceId = localStorage.getItem('DeviceId')
  if (DeviceId === null) {
    const deviceId = uuidv1()
    localStorage.setItem('DeviceId', deviceId)
    return deviceId
  }
  return DeviceId
}

export default generateDeviceId()



//////////////////
// WEBPACK FOOTER
// ./plugins/deviceId.js
// module id = null
// module chunks = 